import React from 'react';

import * as S from './styled';

const SetupBullet = ({ text }: { text: string }) => {
  const sepIdx = text.indexOf(' - ');
  if (sepIdx > -1) {
    const title = text.slice(0, sepIdx);
    const sub = text.slice(sepIdx + 3);
    return (
      <S.SetupLiText>
        <strong>{title}</strong>
        <S.SetupLiSub>{sub}</S.SetupLiSub>
      </S.SetupLiText>
    );
  }
  return <S.SetupLiText>{text}</S.SetupLiText>;
};

export type OnboardingSetupCardProps = {
  featured?: boolean;
  popularLabel?: string;
  title: string;
  tagline: string;
  price: React.ReactNode;
  note: string;
  bulletsLabel: string;
  bullets: string[];
  isPurchased?: boolean;
  purchasedTitle: string;
  purchasedDateLabel?: string;
  ctaLabel: string;
  checkoutLoading?: boolean;
  primaryCta?: boolean;
  onCheckout: () => void;
};

export const OnboardingSetupCard = ({
  featured,
  popularLabel,
  title,
  tagline,
  price,
  note,
  bulletsLabel,
  bullets,
  isPurchased,
  purchasedTitle,
  purchasedDateLabel,
  ctaLabel,
  checkoutLoading,
  primaryCta,
  onCheckout,
}: OnboardingSetupCardProps) => (
  <S.SetupCard $featured={featured}>
    {popularLabel ? <S.SetupPopular>{popularLabel}</S.SetupPopular> : null}
    <S.SetupName>{title}</S.SetupName>
    <S.SetupTagline>{tagline}</S.SetupTagline>
    <S.SetupPrice>{price}</S.SetupPrice>
    <S.SetupNote>{note}</S.SetupNote>
    <S.SetupSectionLabel>{bulletsLabel}</S.SetupSectionLabel>
    <S.SetupList>
      {bullets.map((bullet) => (
        <S.SetupLi key={bullet}>
          <S.SetupLiCheck aria-hidden>✓</S.SetupLiCheck>
          <SetupBullet text={bullet} />
        </S.SetupLi>
      ))}
    </S.SetupList>
    <S.SetupCardFooter>
      <S.SetupFooterAction>
        {isPurchased ? (
          <S.SetupPurchased>{purchasedTitle}</S.SetupPurchased>
        ) : (
          <S.SetupCta
            as="button"
            type="button"
            disabled={checkoutLoading}
            onClick={onCheckout}
            style={{ fontFamily: 'inherit' }}
            {...(primaryCta ? { $primary: true } : {})}
          >
            {ctaLabel}
          </S.SetupCta>
        )}
        {isPurchased && purchasedDateLabel ? (
          <S.SetupPurchasedSub>{purchasedDateLabel}</S.SetupPurchasedSub>
        ) : null}
      </S.SetupFooterAction>
    </S.SetupCardFooter>
  </S.SetupCard>
);
